module.exports = require('./lib/effects')